import { useEffect, useState } from 'react'

import { Button, Icon, Label, Select, Table } from 'semantic-ui-react'

import { AreaService, HelperService } from '../../services'

import { AreaCreateForm, ErrorMessage, LoadingSpinner } from '../../components'

import { DropdownOptions } from '../../constants'

import { Area } from '../../models'

export function AdminsysAreasPage() {

    const [areas, setAreas] = useState<Area[]>([])
    const [loadingAreas, setLoadingAreas] = useState<boolean>(true)
    const [errorFetchingAreas, setErrorFetchingAreas] = useState<boolean>(false)
    const [createModalVisible, setCreateModalVisible] = useState<boolean>(false)

    useEffect(() => {

        AreaService.getAreaList('sys')
            .then(data => setAreas(data))
            .catch(err => setErrorFetchingAreas(true))
            .finally(() => setLoadingAreas(false))

    }, [])

    const addAreaToList = (area: Area) => {

        setAreas([area, ...areas])

        HelperService.storeAreas([area, ...areas])
    }

    return <div>

        {errorFetchingAreas && <ErrorMessage />}

        {loadingAreas && <LoadingSpinner />}

        {
            !loadingAreas && !errorFetchingAreas &&
            <>
                <div className="headerRow">
                    <div className='flex-center'>
                        <h3 className='mb-0 mr-25'><Label color='orange'>{areas.length}</Label> Cities</h3>
                        <Select placeholder='Filtrer par région' options={DropdownOptions.regionOptions} className='mr-25' />
                        <Select placeholder='Filtrer par département' options={DropdownOptions.departementsOptions} />
                    </div>
                    <Button color='orange' className='size-16' onClick={() => setCreateModalVisible(true)}>Nouveau</Button>
                </div>
                <Table basic='very'>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell className="size-17">N°</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Région</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Département</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Ville</Table.HeaderCell>
                            <Table.HeaderCell className="size-17">Date de création</Table.HeaderCell>
                            <Table.HeaderCell className="size-17"></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>

                        {areas.map(a =>
                            <Table.Row key={a.id}>
                                <Table.Cell>{a.id}</Table.Cell>
                                <Table.Cell>{a.region}</Table.Cell>
                                <Table.Cell>{a.department}</Table.Cell>
                                <Table.Cell>{a.city}</Table.Cell>
                                <Table.Cell> {a.createdAt?.toLocaleString()}</Table.Cell>
                                <Table.Cell textAlign='right'>

                                    <Button icon className='mr-10'><Icon name='trash alternate' /></Button>
                                    <Button className='mr-10'>Plus</Button>
                                    <Button className='mr-10'><Icon name='pencil alternate' /> Éditer</Button>
                                </Table.Cell>
                            </Table.Row>
                        )}
                    </Table.Body>
                </Table>
            </>
        }

        {createModalVisible && <AreaCreateForm setCreateModalVisible={setCreateModalVisible} addAreaToList={addAreaToList} />}
    </div>
}